import { render } from "./CommunicationPreferences.vue?vue&type=template&id=046b0de7"
import script from "./CommunicationPreferences.vue?vue&type=script&lang=js"
export * from "./CommunicationPreferences.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/members.eena.org/releases/81761477/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__